import React from 'react';
import Linkify from 'tt-react-linkify';
import { FormattedMessage } from 'react-intl';
import styles from './MessageContent.module.css';

export function MessageContent({
  content,
  isAwayMessage,
}: {
  content: string;
  isAwayMessage: boolean;
}) {
  const awayFragment = isAwayMessage ? (
    <>
      <FormattedMessage id={'message.autoReply'} />{' '}
    </>
  ) : (
    ''
  );

  return (
    <Linkify
      className={styles.contentContainer}
      properties={{ rel: ['noopener noreferrer'], target: '_blank' }}
      inlineImages={true}
    >
      {awayFragment}
      {linkifyPhoneNumbers(content)}
    </Linkify>
  );
}

function LinkifiedPhoneNumber({ number }: { number: string }) {
  return (
    <a href={`tel:${normalizePhoneNumber(number)}`} className={styles.phoneNumber}>
      {number}
    </a>
  );
}

function linkifyPhoneNumbers(str: string) {
  const elements = [];
  const matcher = /(?:^|\s)\+?(1[-.● ]?)?\(?([2-9][0-9]{2})\)?[-.● ]?([0-9]{3})[-.● ]?([0-9]{4})(?=$|[^a-zA-Z0-9])/g;
  let lastIndex = 0;

  let match = matcher.exec(str);
  if (!match) return str;

  while (match) {
    const number = match[0];

    if (match.index > lastIndex) {
      elements.push(str.slice(lastIndex, match.index));
    }
    lastIndex = match.index + number.length;

    elements.push(<LinkifiedPhoneNumber key={match.index} number={number} />);
    match = matcher.exec(str);
  }

  if (str.length > lastIndex) {
    elements.push(str.slice(lastIndex));
  }

  return elements;
}

function normalizePhoneNumber(number: string) {
  return number.replace(/\D/g, '');
}

export default MessageContent;
